import React, { useEffect } from 'react';

const GoogleAdsense = ({ 
  adSlot = "3655904089", 
  adFormat = "auto", 
  fullWidthResponsive = true,
  adStyle = { display: 'block' }
}) => {
  useEffect(() => {
    try {
      // AdSense script yüklendiyse reklamı göster
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  return (
    <div className="adsense-container" style={{ margin: '20px 0', textAlign: 'center' }}>
      <ins 
        className="adsbygoogle"
        style={adStyle}
        data-ad-client="ca-pub-8718697977125649"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive.toString()}
      />
    </div>
  );
};

export default GoogleAdsense;
